import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
} from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { map } from '@sama/micro-dash';
import { DirectiveSuperclass } from '@sama/ng-core';
import { filter, skip, startWith } from 'rxjs/operators';
import { FusionManager } from '../../../../../../core/outputs/annotation/annotation-shared/fusion/fusion-manager';
import { EventTrackingService } from '../../../../../../shared/event-tracking/event-tracking.service';
import { ShapeFilterService } from './shape-filter.service';

@Component({
  selector: 'h3-shape-filter',
  templateUrl: './shape-filter.component.html',
  styleUrls: ['./shape-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShapeFilterComponent
  extends DirectiveSuperclass
  implements OnInit
{
  faArrowLeft = faArrowLeft;
  filtersByOutputs!: Array<{
    outputLabel: string;
    filters: Array<{
      formControl: FormControl<boolean | null>;
      filterLabel: string;
    }>;
  }>;
  private formArray = new FormArray<FormControl<boolean | null>>([]);

  constructor(
    injector: Injector,
    private eventTrackingService: EventTrackingService,
    private shapeFilterService: ShapeFilterService,
    private fusionManager: FusionManager,
  ) {
    super(injector);
  }

  ngOnInit() {
    const filtersByOutput = this.fusionManager
      .fusionStore('nestedOutputFilter')
      .state();

    this.filtersByOutputs = map(filtersByOutput, (filterInfo, outputName) => ({
      // @ts-ignore -- fix me
      outputLabel: filterInfo.outputLabel,
      // @ts-ignore -- fix me
      filters: filterInfo.namesAndLabels.map((nameAndLabel, index) => ({
        formControl: this.createFormControl(outputName, index),
        // fix me if you change this code
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
        filterLabel: nameAndLabel.label ?? nameAndLabel.name,
      })),
    }));
  }

  clearFilters() {
    this.updateAllFormControls(false);

    this.eventTrackingService.track({
      id: 'shape_list_filter',
      bucket: 'navigation',
      sub_bucket: 'frame',
      action: 'clear_all',
    });
  }

  resetFilters() {
    this.updateAllFormControls(true);
    this.eventTrackingService.track({
      id: 'shape_list_filter',
      bucket: 'navigation',
      sub_bucket: 'frame',
      action: 'reset_all',
    });
  }

  closeFilterEditor() {
    this.shapeFilterService.closeFilterEditor();
  }

  trackFilterChange() {
    this.eventTrackingService.track({
      id: 'shape_list_filter',
      bucket: 'navigation',
      sub_bucket: 'frame',
      action: 'filter_changed',
    });
  }

  private createFormControl(outputName: string, index: number) {
    const activeStore = this.fusionManager.fusionStore('nestedOutputFilter')(
      outputName,
    )(
      // @ts-ignore -- fix me
      'namesAndLabels',
    )(index)('filterOut');

    const formControl = new FormControl(!activeStore.state());
    this.formArray.push(formControl);

    this.subscribeTo(
      formControl.valueChanges.pipe(startWith(formControl.value)),
      (checked) => {
        // !checked means filterOut
        // @ts-ignore -- fix me
        activeStore.set(!checked);
      },
    );
    this.subscribeTo(
      activeStore.$.pipe(
        skip(1),
        filter((filterOut: boolean) => {
          const checked = formControl.getRawValue();
          return checked !== !filterOut;
        }),
      ),
      (filterOut) => {
        formControl.setValue(!filterOut, { emitEvent: false });
      },
    );

    return formControl;
  }

  private updateAllFormControls(checked: boolean) {
    this.formArray.setValue(this.formArray.controls.map(() => checked));
  }
}
